import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class TranslateInDjango extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        return t(`${this.props.t_key}`);
    }
}

export default withTranslation()(TranslateInDjango);
